import request from '@/utils/request'
import config from '@/config'
export default {
  // 单站雨量表格
  getStatisticsRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsRain', { params })
  },
  // 获得实时水雨情
  getSyntheticalWaterAndRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetSyntheticalWaterAndRain', { params })
  },
  // 获得工程类型
  getprojecttypes (params) {
    return request.get(config.ApiYJ + '/video/getprojecttypes', { params })
  },
  // 获得视频信息
  getvideoresourcesbywhere (params) {
    return request.get(config.ApiYJ + '/video/getvideoresourcesbywhere', { params })
  },
  // 获得台风信息
  getTyhoonActivity (params) {
    return request.get(config.ApiYJ + '/Reference/GetTyhoonActivity', { params })
  },
  // 查询综合雨水情信息 分钟
  getRainWaterMinutesTotal (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetRainWaterMinutesTotal', { params })
  },
  // 获取水库信息
  getStatisticsReservoirWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsReservoirWater', { params })
  },
  // 获取河道水位信息
  getStatisticsRiverWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsRiverWater', { params })
  },
  // 获取水位详情信息
  get5MYuRunData (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/Get5MYuRunData', { params })
  },
  // 获取水库库容曲线
  getStationStorage (params) {
    return request.get(config.ApiYSQ + `/HydrologyCenter/GetStationStorage`, { params })
  },
  // 获得水库
  getReservoir (params) {
    return request.get(config.ApiYJ + '/basic/GetReservoir', { params })
  },
  // 获得河流
  getRiver (params) {
    return request.get(config.ApiYJ + '/basic/GetRiver', { params })
  },
  // 获得雨量预警图片
  getStsUrl(params) {
    return request.post(config.ApiYJ + '/oss/getStsUrl', params)
  }
}
